export const GoogleMapApiConfig = 'AIzaSyBPjFys8qeDQhv-TeH_hVmMLbmB1U7TaMY';